/* global Shopify */

Shopify.formatMoney = function(t, e) {
    function o(t, e) {
        return 'undefined' == typeof t ? e : t;
    }

    function i(t, e, i, r) {
        if (
            ((e = o(e, 2)),
            (i = o(i, ',')),
            (r = o(r, '.')),
            isNaN(t) || null == t)
        ) {
            return 0;
        }
        t = (t / 100).toFixed(e);
        const n = t.split('.');
        const a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + i);
        const s = n[1] ? r + n[1] : '';
        return a + s;
    }

    'string' == typeof t && (t = t.replace('.', ''));
    let r = '';
    const n = /\{\{\s*(\w+)\s*\}\}/;
    const a = e || this.money_format;

    switch (a.match(n)[1]) {
        case 'amount':
            r = i(t, 2);
            break;

        case 'amount_no_decimals':
            r = i(t, 0);
            break;

        case 'amount_with_comma_separator':
            r = i(t, 2, '.', ',');
            break;

        case 'amount_with_apostrophe_separator':
            r = i(t, 2);
            break;

        case 'amount_no_decimals_with_comma_separator':
            r = i(t, 0, '.', ',');
            break;

        case 'amount_no_decimals_with_space_separator':
            r = i(t, 0, '&nbsp;');
            break;

        case 'amount_with_space_separator':
            r = i(t, 2, '&nbsp;', ',');
            break;
    }

    return a.replace(n, r);
};
